import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import CodeValidation from "./pages/CodeValidation";
import routes from "./_routes";

const AppRouter = () => {
  let param = new URLSearchParams(useLocation().search);

  const siteId = param.get("siteId") !== null ? param.get("siteId") : null;
  const code = param.get("code") !== null ? param.get("code") : null;

  return (
    <Switch>
      {routes.map((route, idx) => {
        return route.component ? (
          siteId !== null && code !== null ? (
            <CodeValidation key="CodeValidation" />
          ) : (
            <Route key={idx} path={route.path} exact={route.exact} name={route.name} render={(props) => <route.component {...props} />} />
          )
        ) : null;
      })}
      <Redirect from="/" to="" />
    </Switch>
  );
};

export default AppRouter;
